import { Button, ButtonProps } from "@suraasa/placebo-ui"
import { NavArrowLeft, NavArrowRight } from "iconoir-react"
import { useNavigate } from "react-router-dom"

const BackButton = ({
  onClick,
  label = "Back",
  className: userClassName,
  ...otherProps
}: ButtonProps) => {
  const navigate = useNavigate()
  return (
    <Button
      variant="text"
      color={otherProps.color}
      onClick={onClick ? onClick : () => navigate(-1)}
      className={userClassName}
      {...otherProps}
    >
      <span className="inline-flex items-center gap-0.5">
        <NavArrowLeft className="rtl:hidden" />
        <NavArrowRight className="ltr:hidden" />
        {label}
      </span>
    </Button>
  )
}

export default BackButton
